import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import { reportStaffOnline } from "./thunkAction";

const initialState = {
  reportStaffOnline: [],
};

const staffStatsSlice = createSlice({
  name: "staffStatsManage",
  initialState,
  reducers: {
    clearReportStaffOnline(state) {
      state.reportStaffOnline = {};
    },
  },
  extraReducers: (builder) => {
    builder
      //reportStaffOnline
      .addCase(reportStaffOnline.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(reportStaffOnline.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.reportStaffOnline = _.get(action, "payload", {});
      })
      .addCase(reportStaffOnline.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const staffStatsReducer = staffStatsSlice.reducer;

export const staffStatsAction = staffStatsSlice.actions;
